import { useState } from "react";
import { styled, Typography, Stack } from "@mui/material";
import { Block } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { FallbackProps } from "react-error-boundary";

import { useLegendImage } from "hooks/legendHooks";

import { IndicatorSelection, Indicator, LayerProperties } from "types";

interface Props extends FallbackProps {
  config: string;
  selection: IndicatorSelection;
  indicator: Indicator;
  layerProperties: LayerProperties[];
}

export function LegendItemErrorImageFallBack(props: Props) {
  const { config, indicator, layerProperties } = props;
  const { t } = useTranslation();
  const { data: legendImageUrl } = useLegendImage(
    config,
    indicator,
    "image/png",
    layerProperties
  );
  const [loadStatus, setLoadStatus] = useState<"init" | "complete" | "error">(
    "init"
  );
  function onLoad() {
    setLoadStatus("complete");
  }

  function onError() {
    setLoadStatus("error");
  }

  return (
    <>
      <StyledImage
        className={loadStatus}
        onError={onError}
        onLoad={onLoad}
        src={legendImageUrl}
        alt="legend fallback"
      />
      {loadStatus === "error" && (
        <Stack direction="row" spacing={1} alignItems="center">
          <Block className="error-icon" />
          <Typography>{t("label.unableToLoadLegend")}</Typography>
        </Stack>
      )}
    </>
  );
}

const StyledImage = styled("img")`
  &.init,
  &.completed {
    display: block;
  }

  &.init {
    visibility: hidden;
  }

  &.error {
    display: none;
  }
`;
